import React from 'react';
import './progressBar.css';

const ProgressBar = props => {
	const { id, progress, value, percent, outOf, title, small, edit, dataTestId } = props;
	const colour = props.colour ? props.colour : 'aqua';

	return (
		<div className="progress-group" data-testid={dataTestId ? dataTestId : id ? `progress-${id}` : undefined}>
			<span className="progress-text">{title}</span>
			<span className="progress-number">
				<div className="flex">
					<div className="flex-grow">
						<b>{value || progress}</b>
						{outOf ? <span> / {outOf}</span> : percent ? '%' : ''}
					</div>
					{edit && (
						<div className="ml5">
							<i onClick={edit} className="pointer fa fa-pencil" />
						</div>
					)}
				</div>
			</span>
			<div className={`progress ${small ? 'sm' : ''}`}>
				<div className={`progress-bar progress-bar-${colour}`} style={{ width: `${progress}%` }} />
				<div className={`progress-bar progress-bar-disabled`} style={{ width: `${100 - progress}%` }} />
			</div>
		</div>
	);
};

export default ProgressBar;
